import { Injectable } from '@angular/core';
import { TvDashboardDataService } from '@monorepo/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators';
import * as TvDashboardActions from './tv-dashboard.actions';
import { TTvDashboardActionType } from './tv-dashboard.model';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TvDashboardEffects {
  constructor(private action$: Actions, private dataService: TvDashboardDataService) {}

  connectWebSocket$ = createEffect(() =>
    this.action$.pipe(
      ofType(TTvDashboardActionType.ConnectWebSocket),
      switchMap((action: TvDashboardActions.ConnectWebSocket) => {
        this.dataService.createWebSocket(action.wsConfig, action.reason);
        return this.dataService.getConnectionStatus().pipe(
          map((status) => {
            if (status === 'CONNECTED') {
              // Dispatch both actions when connected
              return [new TvDashboardActions.WebSocketStatus(status), new TvDashboardActions.StartListeningMessages()];
            }
            return [new TvDashboardActions.WebSocketStatus(status)];
          }),
          catchError(() => of([new TvDashboardActions.WebSocketStatus('ERROR')])),
        );
      }),
      mergeMap((actions) => actions),
    ),
  );

  listenToMessages$ = createEffect(() =>
    this.action$.pipe(
      ofType(TTvDashboardActionType.StartListeningMessages),
      switchMap(() =>
        this.dataService.listenToEvent().pipe(
          map((message) => {
            console.log('[LISTEN TO MESSAGES]', message);
            return new TvDashboardActions.UpdateData(message.channel_id, message.message);
          }),
          takeUntil(this.action$.pipe(ofType(TTvDashboardActionType.DisconnectWebSocket))),
        ),
      ),
    ),
  );

  disconnectWebSocket$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(TTvDashboardActionType.DisconnectWebSocket),
        switchMap(() => {
          this.dataService.disconnectWebSocket();
          return [];
        }),
      ),
    { dispatch: false },
  );

  sendDataToWebsocket$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(TTvDashboardActionType.SendDataToWebsocket),
        switchMap((action: TvDashboardActions.SendDataToWebsocket) => {
          this.dataService.sendWebSocketMessage(action.payload);
          return of(null);
        }),
      ),
    { dispatch: false },
  );
}
